var _regeneratorRuntime = require("@babel/runtime/regenerator");

module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/index.ts");
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  "./src/index.ts":
  /***/
  function srcIndexTs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "StorybookProps", function () {
      return StorybookProps;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "StorybookFunctions", function () {
      return StorybookFunctions;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "getClient", function () {
      return getClient;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "default", function () {
      return GoogleTagManagerClient;
    });
    /* harmony import */


    var _carvana_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("@carvana/analytics");
    /* harmony import */


    var _carvana_analytics__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_carvana_analytics__WEBPACK_IMPORTED_MODULE_0__);

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function _asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      subClass.__proto__ = superClass;
    }

    var StorybookProps = function StorybookProps(config) {
      return null;
    };

    var StorybookFunctions = function StorybookFunctions(func) {
      return null;
    };

    function getClient(id) {
      return Promise.resolve(Object(_carvana_analytics__WEBPACK_IMPORTED_MODULE_0__["getAnalyticsClient"])('dataLayer', "https://www.googletagmanager.com/gtm.js?id=" + id, function (cb) {
        return cb && typeof cb === 'function' && cb();
      }));
    }

    var GoogleTagManagerClient = /*#__PURE__*/function (_BaseClient) {
      _inheritsLoose(GoogleTagManagerClient, _BaseClient);

      function GoogleTagManagerClient(config) {
        var _this;

        _this = _BaseClient.call(this, 'googletagmanager', config) || this;
        _this.config = config;

        _this.trackEvent = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(eventName, eventData, log, noPublish) {
            var trackConversionGoogleTagManager;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (eventData === void 0) {
                      eventData = {};
                    }

                    _context.next = 3;
                    return getClient(_this.config.id);

                  case 3:
                    trackConversionGoogleTagManager = _context.sent;

                    if (trackConversionGoogleTagManager) {
                      if (log) {
                        log('[Analytics_GoogleTagManaer_Event]', {
                          eventName: eventName,
                          eventData: eventData
                        });
                      }

                      if (!noPublish) {
                        trackConversionGoogleTagManager.push(_extends({}, eventData));
                      }
                    }

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x, _x2, _x3, _x4) {
            return _ref.apply(this, arguments);
          };
        }();

        _this.trackUser = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(eventName, eventData, log, noPublish) {
            var trackConversionGoogleTagManager, _eventData, userId;

            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (eventData === void 0) {
                      eventData = {};
                    }

                    _context2.next = 3;
                    return getClient(_this.config.id);

                  case 3:
                    trackConversionGoogleTagManager = _context2.sent;
                    _eventData = eventData, userId = _eventData.userId;

                    if (trackConversionGoogleTagManager) {
                      if (log) {
                        log('[Analytics_GoogleTagManaer_User]', {
                          eventName: eventName,
                          eventData: eventData
                        });
                      }

                      if (!noPublish) {
                        trackConversionGoogleTagManager.push({
                          uid: userId
                        });
                      }
                    }

                  case 6:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x5, _x6, _x7, _x8) {
            return _ref2.apply(this, arguments);
          };
        }();

        getClient(config.id).then(function (res) {
          if (res) {
            res.push({
              'gtm.start': new Date().getTime(),
              event: 'gtm.js'
            });
          }
        });
        return _this;
      }

      return GoogleTagManagerClient;
    }(_carvana_analytics__WEBPACK_IMPORTED_MODULE_0__["BaseClient"]);
    /***/

  },

  /***/
  "@carvana/analytics":
  /***/
  function carvanaAnalytics(module, exports) {
    module.exports = require("@carvana/analytics");
    /***/
  }
  /******/

});